/**
 * Generates a random identifier string.
 *
 * @returns A random identifier string in the format 'id-<alphanumeric>'.
 */
export function randomId(): string {
  const randomString = Math.random().toString(36).substring(2, 11);
  const timestampString = Date.now().toString(36).slice(-4);

  return `id-${randomString}-${timestampString}`;
}
